<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-body">
            <h5 class="card-title text-center"><strong>SkillLink Terms of Use</strong></h5>
            <p><strong>Last Updated:</strong> August 1, 2024</p>
            <p>
              PLEASE READ THESE TERMS OF USE CAREFULLY. BY ACCESSING OR USING ANY SKILLLINK WEBSITE OR APPLICATIONS (OR ANY CONTENT, PRODUCT, SERVICE, OR FEATURE AVAILABLE THROUGH THE WEBSITE OR APPLICATIONS) (COLLECTIVELY, THE “SITE”), YOU AGREE TO ABIDE BY AND BE BOUND BY THESE TERMS AND ALL POLICIES INCORPORATED BY REFERENCE. IF YOU DO NOT AGREE, DO NOT USE THE SITE.
            </p>
            <p>
              These Terms are not intended to alter any content license agreement you may have with SkillLink. By using the Site, you represent and warrant that you are over 18 and have the authority to accept these Terms on behalf of any entity you represent.
            </p>
            <h6><strong>Privacy Policy</strong></h6>
            <p>SkillLink is committed to protecting your privacy. Please refer to our <router-link to="/privacy-policy" class="text-primary">Privacy Policy</router-link> for information on how we collect, use, and disclose personal information.</p>
            <h6><strong>Ownership and Use</strong></h6>
            <p>
              The Site and its content are owned by SkillLink. You may not use the Site or its content for any purpose not related to your business with SkillLink. Prohibited actions include downloading, copying, or re-transmitting content without a license, using data mining methods, and altering any part of the Site or its content.
            </p>
            <h6><strong>Copyright Policy</strong></h6>
            <p>
              SkillLink has a policy of terminating accounts that infringe intellectual property rights. If you believe material infringes your copyright, you may file a notification with our Designated Agent.
            </p>
            <h6><strong>Links</strong></h6>
            <p>
              SkillLink is not responsible for third-party websites linked from the Site. Use these links at your own risk and review the applicable terms and policies of any third-party site.
            </p>
            <h6><strong>Interactive Areas</strong></h6>
            <p>
              The Site may include discussion forums or interactive areas. You are responsible for your use of these areas and agree not to post illegal, defamatory, or harmful content. SkillLink reserves the right to remove any such content at its discretion.
            </p>
            <p class="text-center">
              <router-link to="/terms-conditions" class="text-primary">Terms and Conditions</router-link> | <router-link to="/privacy-policy" class="text-primary">Privacy Policy</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
a {
  text-decoration: none;
  color: rgb(107, 115, 133);
}

a:hover {
  text-decoration: underline;
  text-transform: initial;
}

.container {
  max-width: 800px;
}
</style>
